module.exports = __webpack_public_path__ + "img/korea.7c7e61b2.svg";